/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBomTreeArticle } from './APIBomTreeArticle';
import {
    APIBomTreeArticleFromJSON,
    APIBomTreeArticleFromJSONTyped,
    APIBomTreeArticleToJSON,
} from './APIBomTreeArticle';

/**
 * 
 * @export
 * @interface APIBomTreeResult
 */
export interface APIBomTreeResult {
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeResult
     */
    articleId: string;
    /**
     * 
     * @type {APIBomTreeArticle}
     * @memberof APIBomTreeResult
     */
    article: APIBomTreeArticle;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof APIBomTreeResult
     */
    paths: Array<Array<string>>;
    /**
     * 
     * @type {number}
     * @memberof APIBomTreeResult
     */
    pathCount: number;
}

/**
 * Check if a given object implements the APIBomTreeResult interface.
 */
export function instanceOfAPIBomTreeResult(value: object): value is APIBomTreeResult {
    if (!('articleId' in value) || value['articleId'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('paths' in value) || value['paths'] === undefined) return false;
    if (!('pathCount' in value) || value['pathCount'] === undefined) return false;
    return true;
}

export function APIBomTreeResultFromJSON(json: any): APIBomTreeResult {
    return APIBomTreeResultFromJSONTyped(json, false);
}

export function APIBomTreeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBomTreeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'articleId': json['article_id'],
        'article': APIBomTreeArticleFromJSON(json['article']),
        'paths': json['paths'],
        'pathCount': json['path_count'],
    };
}

export function APIBomTreeResultToJSON(value?: APIBomTreeResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'article_id': value['articleId'],
        'article': APIBomTreeArticleToJSON(value['article']),
        'paths': value['paths'],
        'path_count': value['pathCount'],
    };
}

